// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm-module--form--2n-as","submit":"ContactForm-module--submit--1U3Z2","title":"ContactForm-module--title--2laZ1","phone":"ContactForm-module--phone--28EfF"};